import React, { useLayoutEffect } from 'react';
import { StyleSheet } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import Amount from 'design-system/Amount';
import { IconCoins } from 'design-system/icons';
import { AppView, rem, withAnimatedNavigationHeader } from 'design-system';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import { useRedemptions } from 'hooks';
import useColors from 'hooks/useColors';
import RewardsScreenContent from 'features/rewards/components/RewardsScreenContent';
import { isWeb } from '../../constants';
const RewardsScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const colors = useColors();
    const scrollY = useSharedValue(0);
    const { redemptions } = useRedemptions();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => (<NavigationHeaderRightIconButton onPress={() => navigation.navigateDeprecated('ClaimRewards')} style={styles.headerRight}>
            <IconCoins color={colors.elements.primary}/>
            {redemptions.available?.currency ? (<Amount Numbers-14 value={{
                        amount: redemptions.available?.balance,
                        currency: redemptions.available?.currency,
                    }}/>) : null}
          </NavigationHeaderRightIconButton>),
        });
    }, [
        colors.elements.primary,
        redemptions.available?.balance,
        redemptions.available?.currency,
    ]);
    return (<AppView withFrame={false}>
        <RewardsScreenContent onScroll={scrollHandler} scrollY={scrollY}/>
      </AppView>);
}, ({ colors }) => ({
    title: 'Cashback',
    headerTintColor: colors.text.primary,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    headerRight: {
        position: 'absolute',
        right: 0,
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(4),
        ...(isWeb && { width: 'auto', paddingHorizontal: rem(16) }),
    },
});
export default RewardsScreen;
